<div class="card-header bg-white" *ngIf="accessService.authorized(project, 'EDIT_COSTS')">

    <ng-template #authTemplate><div [innerHtml]="accessService.authReason(project, 'EDIT_COSTS')"></div></ng-template>
    <button type="button" class="btn btn-primary" placement="right" containerClass="auth-tooltip"
            *ngIf="viewMode === ViewMode.VIEW"
            (click)="setMode(ViewMode.EDIT)"
            [tooltip]="authTemplate"
            [delay]="500">Bearbeiten
    </button>

    <ng-container *ngIf="viewMode === ViewMode.EDIT">
        <button type="button" class="btn btn-success" [disabled]="form.invalid" (click)="update()">Speichern</button>
        <button type="button" class="btn btn-secondary ms-2" (click)="cancelEdit()">Abbrechen</button>
    </ng-container>
</div>
<div class="card-body">
    <form [formGroup]="form">

        <h4>Geplante Kosten</h4>

        <p *ngIf="getLengthOfFormArray('costs') === 0">Keine Kosten definiert.</p>

        <table class="table table-striped table-sm" *ngIf="getLengthOfFormArray('costs') > 0">
            <thead>
            <tr>
                <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th>Kostenart</th>
                <th>Beschreibung</th>
                <th style="text-align: right">Betrag [€]</th>
            </tr>
            </thead>
            <tbody formArrayName="costs">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'costs').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry, true)"><i
                                class="fas fa-trash"></i></button>
                    </td>
                    <td>
                        <select class="form-control" formControlName="id_cost_type" *ngIf="viewMode !== ViewMode.VIEW">
                            <option *ngFor="let costType of costTypeList" [ngValue]="costType.id">
                                {{ costType.name }}
                            </option>
                            <option value="">Nicht gesetzt</option>
                        </select>
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.cost_type }}</ng-container>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="description"
                               *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.description }}</ng-container>
                    </td>
                    <td style="text-align: right">
                        <input type="number" class="form-control" formControlName="amount"
                               *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.amount | number }}</ng-container>
                    </td>
                </ng-container>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <th *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th>Summe</th>
                <th></th>
                <th style="text-align: right">{{sumAmountPlanned | number }}</th>
            </tr>
            </tfoot>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3" (click)="addFormItemCosts({}, 'costs')">
                <i class="fas fa-plus"></i> Kosten hinzufügen
            </button>
        </div>

        <h4>Budgeterweiterung</h4>

        <p *ngIf="getLengthOfFormArray('budget') === 0">Keine Budgeteinträge erstellt.</p>

        <ng-template #approveBudgetTemplate><div [innerHtml]="accessService.authReason(project, 'APPROVE_BUDGET')"></div></ng-template>
        <ng-template #addBudgetTemplate><div [innerHtml]="accessService.authReason(project, 'ADD_BUDGET')"></div></ng-template>
        <table class="table table-striped table-sm" *ngIf="getLengthOfFormArray('budget') > 0">
            <thead>
            <tr>
                <th style="width: 160px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th style="width: 130px">Erstellt am</th>
                <th style="width: 200px">Erstellt von</th>
                <th style="width: 150px; text-align: right">Abweichung [€]</th>
                <th style="width: 150px; text-align: right">Abweichung [%]</th>
                <th style="width: 150px; text-align: right">Neuer Gesamtbetrag [€]</th>
                <th style="width: 130px">Freigegeben am</th>
                <th style="width: 200px">Freigegeben von</th>
                <th>Kommentar</th>
            </tr>
            </thead>
            <tbody formArrayName="budget">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'budget').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry, true)"><i
                            class="fas fa-trash"></i></button>
                        <button type="button" class="btn btn-success btn-sm ms-2"
                                [tooltip]="approveBudgetTemplate"
                                (click)="approveEntry(entry)"
                                *ngIf="!entry.value.approved_at && accessService.authorized(project, 'APPROVE_BUDGET')"><i
                            class="fas fa-check"></i> Freigeben</button>
                    </td>
                    <td>
                        {{ entry.value.created_at | date: 'dd.MM.yyyy' }}
                    </td>
                    <td>
                        {{ entry.value.creator ?? 'Freigabe' }}
                    </td>
                    <td style="text-align: right">
                        <input type="number" class="form-control" formControlName="amount" *ngIf="viewMode !== ViewMode.VIEW && entry.value.approved_at === null">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW || entry.value.approved_at !== null">
                            <span *ngIf="entry.value.amount / sumAmountPlanned * 100 > 0">+</span>{{ entry.value.amount | number }}
                        </ng-container>
                    </td>
                    <td style="text-align: right"
                        [class.text-success]="entry.value.amount / sumAmountPlanned * 100 < 0"
                        [class.text-danger]="entry.value.amount / sumAmountPlanned * 100 > 0">
                        <span *ngIf="entry.value.amount / sumAmountPlanned * 100 > 0">+</span>{{ entry.value.amount / sumAmountPlanned * 100 | number: '1.0' }}%
                    </td>
                    <td style="text-align: right">
                        {{ sumAmountPlanned + +(entry.value.amount) | number }}
                    </td>
                    <td>
                        {{ entry.value.approved_at | date: 'dd.MM.yyyy' }}
                    </td>
                    <td>
                        {{ entry.value.approver }}
                        <span class="text-muted" *ngIf="!entry.value.approved_at">Noch nicht freigegeben</span>
                        <span *ngIf="entry.value.approved_at && !entry.value.approver">Freigabe</span>
                    </td>
                    <td>
                        <input type="text" class="form-control" formControlName="comment"
                               *ngIf="viewMode !== ViewMode.VIEW && entry.value.approved_at === null">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW || entry.value.approved_at !== null">{{ entry.value.comment }}</ng-container>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3"
                    [tooltip]="addBudgetTemplate"
                    *ngIf="formService.getFormArray(form, 'budget').controls.length === 0 || accessService.authorized(project, 'ADD_BUDGET')"
                    (click)="addFormItemBudget({creator: accessService.user.name}, 'budget')">
                <i class="fas fa-plus"></i> Budgeteintrag hinzufügen
            </button>
        </div>

        <!--<div class="row">
            <div class="col">
                <div class="mb-2">
                    <label>Budget [€]</label>
                    <input type="number" class="form-control" formControlName="cost_budget" *ngIf="viewMode !== ViewMode.VIEW">
                    <p *ngIf="viewMode === ViewMode.VIEW">
                        {{ form.value.cost_budget | number }}
                        <span class="text-muted" *ngIf="!form.value.cost_budget">Nicht eingetragen</span>
                    </p>
                </div>
            </div>
        </div>-->


        <!--<h4>IST Kosten</h4>

        <div *ngIf="viewMode !== ViewMode.VIEW">
            <button type="button" class="btn btn-primary btn-sm mb-3" (click)="addFormItemInvoices({}, 'invoices')">
                <i class="fas fa-plus"></i> Rechnung hinzufügen
            </button>
        </div>

        <p *ngIf="getLengthOfFormArray('invoices') === 0">Keine Rechnungen gespeichert.</p>

        <table class="table table-striped table-sm" *ngIf="getLengthOfFormArray('invoices') > 0">
            <thead>
            <tr>
                <th style="width: 50px" *ngIf="viewMode !== ViewMode.VIEW"></th>
                <th style="text-align: right">Betrag [€]</th>
                <th style="text-align: right">Verbrauch [%]</th>
            </tr>
            </thead>
            <tbody formArrayName="invoices">
            <tr [formGroupName]="i"
                *ngFor="let entry of formService.getFormArray(form, 'invoices').controls; let i = index">
                <ng-container *ngIf="!entry.value._deleted">
                    <td *ngIf="viewMode !== ViewMode.VIEW">
                        <button type="button" class="btn btn-danger btn-sm" (click)="markEntryAsDeleted(entry)"><i
                                class="fas fa-times-fw"></i></button>
                    </td>
                    <td style="text-align: right">
                        <input type="number" class="form-control" formControlName="amount"
                               *ngIf="viewMode !== ViewMode.VIEW">
                        <ng-container *ngIf="viewMode === ViewMode.VIEW">{{ entry.value.amount | number }}</ng-container>
                    </td>
                    <td style="text-align: right">
                        <span *ngIf="entry.value.amount && form.value.cost_budget"
                              [class.text-danger]="entry.value.amount / form.value.cost_budget > 1"
                              [class.text-success]="entry.value.amount / form.value.cost_budget < 1">
                            {{ entry.value.amount / form.value.cost_budget * 100 | number }}
                        </span>
                    </td>
                </ng-container>
            </tr>
            </tbody>
        </table>-->
    </form>
</div>
